import BaseModal from "./BaseModal";

export interface IPopupOffset {
    Left: string;
    Top: string;
}

export interface IBaseModalProps {
    BorderRadius?: string;
    CloseButtonHoverColor?: string;
    children: React.ReactNode;
    CloseAriaLabel?: string;
    CloseTitle?: string;
    DisableClose?: boolean;
    FooterColor?: string;
    Header: string;
    HeaderColor?: string;
    HeaderTextColor?: string;
    Height: string;
    ListenToBackgroundClick?: boolean;
    MarginTopBottom?: string;
    Offset?: IPopupOffset;
    OnCloseRequest: () => void;
    RenderFooter?: () => JSX.Element;
    Width: string;
}

export { BaseModal };
